/**
 * Wiki is shown only when BOTH are true:
 * - Vite dev mode (import.meta.env.DEV) — replaced with `false` in production builds.
 * - Explicit opt-in: VITE_WIKI_ENABLED=true in .env.local or .env.development.
 * Stage/prod must never set VITE_WIKI_ENABLED, so even an accidental dev build won't show the wiki.
 *
 * Lives in config/ (not constants/) so vite.config.ts never imports this — config imports constants,
 * and evaluating import.meta.env during config load in Node would throw.
 */
export const IS_WIKI_ENABLED =
	import.meta.env.DEV && import.meta.env.VITE_WIKI_ENABLED === 'true'
